module.exports = __webpack_public_path__ + "assets/img/00015.b07e4c21.png";